module.exports = __webpack_public_path__ + "static/media/Monde_Cocktail_etager.d08790f9.png";